export const adminProfileKeys = {
  base: ["adminProfile"] as const,
  details: () => [...adminProfileKeys.base, "details"] as const,
} as const;
